// src/icons/BoxIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
function BoxIcon({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 24,
    viewBox: "0 0 25 24",
    width: 25,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx("path", {
        d: "M11.75 20.1498V12.4248L5 8.5248V16.2498L11.75 20.1498ZM13.25 20.1498L20 16.2498V8.4998L13.25 12.4248V20.1498ZM11.75 21.8748L4.25 17.5498C4.01667 17.4165 3.83333 17.2331 3.7 16.9998C3.56667 16.7665 3.5 16.5165 3.5 16.2498V7.7498C3.5 7.48314 3.56667 7.23314 3.7 6.9998C3.83333 6.76647 4.01667 6.58314 4.25 6.4498L11.75 2.1248C11.9833 1.99147 12.2333 1.9248 12.5 1.9248C12.7667 1.9248 13.0167 1.99147 13.25 2.1248L20.75 6.4498C20.9833 6.58314 21.1667 6.76647 21.3 6.9998C21.4333 7.23314 21.5 7.48314 21.5 7.7498V16.2498C21.5 16.5165 21.4333 16.7665 21.3 16.9998C21.1667 17.2331 20.9833 17.4165 20.75 17.5498L13.25 21.8748C13.0167 22.0081 12.7667 22.0748 12.5 22.0748C12.2333 22.0748 11.9833 22.0081 11.75 21.8748ZM16.6 8.7498L19.15 7.2748L12.5 3.4248L9.95 4.8998L16.6 8.7498ZM12.5 11.1498L15.1 9.6248L8.425 5.7748L5.825 7.2748L12.5 11.1498Z",
        fill: "currentColor"
      })
    ]
  });
}
export {
  BoxIcon
};
//# sourceMappingURL=BoxIcon.mjs.map